import { defineAsyncComponent } from 'vue'

// Yalnız özel onam formunda kullanılır; Quill ilk pakete girmesin diye ilk kullanımda yüklenir.
// Legacy `vue-editor` adı CompatVueEditor'dır (Aşama 4.4); v-model ve olaylar iç bileşene geçer.
export default {
  install(app) {
    app.component("VueEditor", defineAsyncComponent(() => import(/* webpackChunkName: "vue-editor" */ '../components/shared/CompatVueEditor.vue')))
  }
}
